import Network from './network';
import ApiConfig from '../../config/ApiConfig';
import { IFilter } from '../types/context';

enum filterPropType {
  Org = 1,
}

const getQueryByFilters = (filters: IFilter, type?: number) => {
  const selectedFilters: any = { ...filters.dateRange };

  const extractSelectedOrganisations = (
    selectedOrganisations: Map<any, boolean>,
  ) => {
    return Array.from(selectedOrganisations.entries())
      .filter(([, isSelected]) => isSelected)
      .map(([id]) => id);
  };

  if (type == filterPropType.Org) {
    if (filters.selectedOrganisations.size) {
      const arrayOfOrganisations = extractSelectedOrganisations(
        filters.selectedOrganisations,
      );
      if (arrayOfOrganisations.length) {
        selectedFilters.organisationId = arrayOfOrganisations;
      }
    }
  } else {
    // selectedFilters.dateRange = { ...filters.dateRange };
    if (filters.ageFilter?.length) {
      selectedFilters.age = filters.ageFilter;
    }

    if (filters.genderFilter?.length) {
      selectedFilters.gender = filters.genderFilter;
    }

    if (filters.selectedDepartments.size) {
      const arrayOfDepartments = Array.from(
        filters.selectedDepartments.entries(),
      )
        .filter(([, isSelected]) => isSelected)
        .map(([id]) => id);

      if (arrayOfDepartments.length) {
        selectedFilters.teamIds = arrayOfDepartments;
      }
    }

    if (filters.selectedOrganisations.size) {
      const arrayOfOrganisations = extractSelectedOrganisations(
        filters.selectedOrganisations,
      );
      if (arrayOfOrganisations.length) {
        selectedFilters.organisationId = arrayOfOrganisations;
      }
    }

    if (filters.regionFilter?.length) {
      selectedFilters.country = filters.regionFilter;
    }
  }

  return selectedFilters;
};

export const getReportsData = async () => {
  const response = await Network.get({
    url: ApiConfig.api.getReportsData,
  });
  return response.data;
};

export const getReportsGenerateData = async (
  generateReportArgs: any,
  filters: any,
) => {
  const response = await Network.post({
    url: ApiConfig.api.getReportsData,
    body: {
      fromDate: generateReportArgs.fromDate,
      toDate: generateReportArgs.toDate,
      reportType: generateReportArgs.reportType,
      fileType: generateReportArgs.fileType,
    },
    params: filters,
  });
  return response.data;
};

export const getReportsDownloadData = async (downloadReportArgs: any) => {
  const response = await Network.get({
    url: `${ApiConfig.api.getReportsData}/${downloadReportArgs}`,
  });
  return response;
};

export const getTeamsAndCountries = async () => {
  const response = await Network.get({
    url: ApiConfig.api.getTeamsAndCountries,
  });
  return response.data;
};

export const getOrganisations = async (filters: any) => {
  const coachListUrl = ApiConfig.api.getOrganisations;
  const response = await Network.get({
    url: coachListUrl,
    params: getQueryByFilters(filters, filterPropType.Org),
  });
  return response.data;
};
